import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class HotelSpecialOfferView extends React.Component {
  render() {
    const hotel = this.props.hotel;
    return (
      <div className="row">
        <div className="col-md-12 hotel-details-description">
          <h4 className="hotel-highlight hotel-special-offer-label">
            Special Offer &nbsp;<Button onClick={this.props.handleEdit}>Edit</Button>
          </h4>
          <p className="hotel-special-offer">{hotel.special_offer}</p>
        </div>
      </div>
    );
  }
}
HotelSpecialOfferView.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default HotelSpecialOfferView;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelSpecialOfferView.js